// Перехват console-методов — вызываем первым, чтобы захватить все логи с момента старта
import { initConsoleInterceptor } from '@/utils/consoleInterceptor'
initConsoleInterceptor()

import './assets/main.scss'
import 'remixicon/fonts/remixicon.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { vuetify } from './plugins/vuetify'
import { i18n } from './plugins/i18n'
import { preloadExternalScripts } from '@/utils/loadExternalScript'

const app = createApp(App)

app.config.errorHandler = (err, instance, info) => {
  console.group('VUE RUNTIME ERROR')
  console.error('err:', err)
  console.error('info:', info)
  console.error('component:', instance?.$?.type)
  console.error('component:', instance?.$?.type?.name || instance?.$?.type)
  console.groupEnd()
}

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(vuetify)

app.mount('#app')

// Фоновая загрузка CDN (TG login, ЮKassa, SSP) — после pinia, логи createLog работают
preloadExternalScripts()

/*
 * Регистрация PWA Service Worker — только вне Telegram Mini App.
 * Внутри Telegram SW не нужен: контент через WebView, установка PWA невозможна.
 * Используем нативную регистрацию, чтобы предотвратить автоперезагрузки страницы.
 */
if (!window.Telegram?.WebApp?.initData) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then(reg => {
          console.log('[PWA] Service Worker registered:', reg.scope)
        })
        .catch(err => {
          console.warn('[PWA] Service Worker registration failed:', err)
        })
    })
  }
}
